import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.element.classList.add("translate-y-0", "opacity-100")
        this.element.classList.remove("-translate-y-full", "opacity-0")

        // Auto-dismiss after 4 seconds
        this.timeout = setTimeout(() => {
            this.close()
        }, 4000)
    }

    close() {
        clearTimeout(this.timeout)
        this.element.classList.remove("translate-y-0", "opacity-100")
        this.element.classList.add("-translate-y-full", "opacity-0")

        // Remove from DOM after animation
        setTimeout(() => {
            this.element.remove()
        }, 300)
    }
}
